import { render, staticRenderFns } from "./yb.vue?vue&type=template&id=65abbe1d&scoped=true&"
import script from "./yb.vue?vue&type=script&lang=js&"
export * from "./yb.vue?vue&type=script&lang=js&"
import style0 from "./yb.vue?vue&type=style&index=0&id=65abbe1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abbe1d",
  null
  
)

export default component.exports